var _path, _rect;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgThumbsUp = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "md-thumbs-up",
    width: 40.074,
    height: 37.001,
    viewBox: "0 0 40.074 37.001",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_70665",
    "data-name": "Path 70665",
    d: "M163.662,101h16.573a3.535,3.535,0,0,0,3.3-2.255l5.5-13.047a3.688,3.688,0,0,0,.251-1.349V80.631c0-2.033-1.638-4.3-3.642-4.3H174.155l1.734-7.853.058-.578a2.793,2.793,0,0,0-.8-1.956L173.2,64,161.06,76.266A3.709,3.709,0,0,0,160,78.877v18.5A3.633,3.633,0,0,0,163.662,101Z",
    transform: "translate(-149.208 -64)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10986",
    "data-name": "Rectangle 10986",
    width: 5.343,
    height: 21.373,
    transform: "translate(0 15.49)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgThumbsUp, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/thumbs-up.228d92e8.svg";
export { ForwardRef as ReactComponent };